/**
 *  Player
 *
 *  Created by Legman on 22/03/2017.
 *
 */

import AudioParams from "./AudioParams";
import Common from "./Common";
import Input from "./Input";
import PussycatView from "./cars/PussycatView";
import RaceCar from "./race/RaceCar";

import isMobile from "ismobilejs";

/**
 * @class
 * @memberOf race
 * @extends RaceCar
 */
export default class Player extends RaceCar {
    /**
     * @param {number} id
     * @param {RaceCarView} [view]
     */
    constructor(id, view) {
        super(id, view || new PussycatView());

        this.turnAccel = 12000;
        this.turnDamping = 0.94;

        /**
         * @type {Audio}
         * @private
         */
        this._engineSFX = null;

        /**
         * @type {Audio}
         * @private
         */
        this._offroadSFX = null;

        /**
         * @type {boolean}
         * @private
         */
        this._playOffroadSFX = false;

        /**
         * @type {number}
         * @private
         */
        this._hitTime = window.performance.now();
    }

    /**
     */
    init() {
        super.init();
    }

    /**
     */
    destroy() {
        this.stopEngineSFX();
        this.stopOffroadSFX();

        super.destroy();
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        this.turnSpeed = 0;

        const input = Common.input;

        if (isMobile.any) {
            if (input.touch) {
                console.log(input.touch.x, p3.View.width * 0.5);
                if (input.touch.x < (p3.View.width - p3.View.width * 0.4) * 0.5) {
                    this.turnSpeed = -this.turnAccel;
                }
                if (input.touch.x > (p3.View.width + p3.View.width * 0.4) * 0.5) {
                    this.turnSpeed = this.turnAccel;
                }
            }
        } else {
            if (input.isKeyDown(Input.keys.A) || input.isKeyDown(Input.keys.LEFT)) {
                this.turnSpeed = -this.turnAccel;
            }
            if (input.isKeyDown(Input.keys.D) || input.isKeyDown(Input.keys.RIGHT)) {
                this.turnSpeed = this.turnAccel;
            }
            if (input.isKeyDown(Input.keys.S) || input.isKeyDown(Input.keys.DOWN)) {
                //this.brake();
            }
        }

        if (this._offroad) {
            this.engine.camera.applyShake(0.1);
            !this._offroadSFX && this.startOffroadSFX();
            this._playOffroadSFX = true;
        } else {
            this._offroadSFX && this.stopOffroadSFX();
            if (this._playOffroadSFX) {
                this._playOffroadSFX = false;
                Common.audio.playSound([
                    "sfx_hit_gravel_00",
                    "sfx_hit_gravel_01",
                    "sfx_hit_gravel_02"
                ]);
            }
        }
        super.update(dt);

        //console.log("PLAYER:", this.getTotalDistance(), this.distance, this.engine.track.length, this.lap);
    }

    /**
     * @param {boolean} [playSound=true]
     */
    takeHit(playSound = true) {
        super.takeHit(playSound);

        Common.audio.playSound("sfx_car_slowdown_skid_00");
    }

    /**
     * @param {RaceCollision} collision
     * @param {RaceCar} car
     */
    onCollisionBegin(collision, car) {
        super.onCollisionBegin(collision, car);

        if (window.performance.now() - this._hitTime > 4000) {
            this._hitTime = window.performance.now();
            Common.audio.playSound(["sfx_carhorn_00", "sfx_carhorn_01", "sfx_carhorn_02", "sfx_carhorn_03"]);
            this.engine.camera.applyShake(1, 30);
        }
    }

    /**
     */
    startEngineSFX() {
        this.stopEngineSFX();

        let name;
        switch (this._id) {
            case 0 : {
                name = "sfx_pussycat_loop_01";
                break;
            }
            case 1 : {
                name = "sfx_turbo_loop_00";
                break;
            }
            case 2 : {
                name = "sfx_dastardly_loop_00";
                break;
            }
            case 3 : {
                name = "sfx_grusome_loop_01";
                break;
            }
            case 4 : {
                name = "sfx_iq_loop_01";
                break;
            }
        }

        const params = new AudioParams();
        params.loop = true;
        this._engineSFX = Common.audio.playSound(name, params);
    }

    stopEngineSFX() {
        if (!this._engineSFX) return;
        this._engineSFX.destroy();
    }

    startOffroadSFX() {
        this.stopOffroadSFX();
        const params = new AudioParams();
        params.loop = true;
        this._offroadSFX = Common.audio.playSound("sfx_offtrack_loop_00", params);
    }

    stopOffroadSFX() {
        if (!this._offroadSFX) return;
        this._offroadSFX.destroy();
        this._offroadSFX = null;
    }
}